/* eslint-disable import/prefer-default-export */
export const HEALTH_POINT = {
  low: 30,
  high: 70,
}
